import React, {Component} from "react";
import {Link, Navigate} from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import EmployerFullRenderer from './EmployerFullRendererComponent'

class EmployerNew extends Component {

    render() {
        console.log('EmployerNew Component render is invoked!');

        const employer = {
            generalSection: {},
            headOffice: {},
            caracterizare: {},
            activitateEconomica: {
                activitatePrincipala: {},
            },
            organizareActivitateProtectie: {},
            medicinaMuncii: {}
        }

        if(this.props.mostRecentEmployerId != null) {
            return(
                <Navigate to={`/employers/${this.props.mostRecentEmployerId}`} replace />
            );
        }
        else {
            return (
                <Container maxWidth="xl" >
                    <Box px={{ xs: 3, sm: 7 }}>

                        <Stack spacing={1} sx={{ marginBottom: 2 }}>
                            <Box>
                                <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                                    <Link to='/employers'>Angajatori</Link>
                                    <Typography color="text.primary">Adauga Angajator</Typography>
                                </Breadcrumbs>
                            </Box>

                            <Box>
                                <h3>Angajator Nou</h3>
                            </Box>
                            <hr />

                            <EmployerFullRenderer
                                isNewEntity={true}
                                employer={employer}
                                clients={this.props.clients}
                                saveEmployer={this.props.postEmployer}
                            />

                        </Stack>

                    </Box>
                </Container>
            );
        }

    }


}
export default EmployerNew